import styled from 'styled-components'

import { fontWeight, color } from 'src/styles'
import { fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const BOTTOM_NAV_HEIGHT_DESKTOP = 8.8
export const BOTTOM_NAV_HEIGHT_MOBILE = 6

export const Wrap = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${BOTTOM_NAV_HEIGHT_MOBILE}rem;
  box-shadow: inset 0 0.1rem 0 0 #eeebeb;
  background-color: ${color.WHITE};

  ${media.desktop} {
    height: ${BOTTOM_NAV_HEIGHT_DESKTOP}rem;
  }
`

export const LinksWrap = styled.ul`
  max-width: 66.8rem;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;

  ${media.desktop} {
    justify-content: space-between;
  }
`

export const LinkWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  ${media.desktop} {
    flex-direction: row;
  }
`

export const LinkText = styled.span<{ isActive: boolean }>`
  font-size: ${fontSize.SMALL_EXTRA};
  font-weight: ${fontWeight.BOLD};
  line-height: 1.14;
  color: ${({ isActive }) =>
    isActive ? color.DUSTY_ORANGE : color.PINKISH_GREY};

  ${media.desktop} {
    margin-left: 1.2rem;
    font-size: ${fontSize.SMALL};
  }
`
